import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Layout from '../components/layout/Layout';
import LessonCard from '../components/common/LessonCard';
import { Progress } from '../components/ui/progress';
import { Button } from '../components/ui/button';
import { useApp } from '../context/AppContext';

const TrackDetailPage = () => {
  const { trackId } = useParams();
  const navigate = useNavigate();
  const { tracks, lessons } = useApp();

  const track = tracks.find(t => t.id === trackId);
  const trackLessons = lessons[trackId] || [];

  if (!track) {
    return (
      <Layout showBack title="Trilha não encontrada">
        <div className="px-4 py-12 text-center">
          <p className="text-muted-foreground">Trilha não encontrada</p>
          <Button onClick={() => navigate('/tracks')} className="mt-4">
            Voltar para Trilhas
          </Button>
        </div>
      </Layout>
    );
  }

  const progress = (track.completedLessons / track.totalLessons) * 100;

  return (
    <Layout showBack title={track.title}>
      <div className="px-4 py-6 space-y-6">
        {/* Track Header */}
        <div className="card-elevated p-5 space-y-4">
          <div className="flex items-start gap-4">
            <span className="text-4xl">{track.icon}</span>
            <div className="flex-1">
              <h1 className="font-display text-xl font-bold">{track.title}</h1>
              <p className="text-sm text-muted-foreground">{track.titlePt}</p>
              <p className="text-sm text-muted-foreground mt-1">{track.description}</p>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Progresso da trilha</span>
              <span className="font-semibold">{track.completedLessons}/{track.totalLessons} lições</span>
            </div>
            <Progress value={progress} className="h-2.5" />
          </div>
        </div>

        {/* Lessons List */}
        <div className="space-y-4">
          <h2 className="font-display font-semibold text-lg">Lições</h2>
          
          <div className="space-y-3">
            {trackLessons.map((lesson, index) => (
              <div key={lesson.id} className="flex items-center gap-3">
                {/* Lesson Number */}
                <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center shrink-0">
                  <span className="text-sm font-medium text-muted-foreground">{index + 1}</span>
                </div>
                
                {/* Lesson Card */}
                <div className="flex-1">
                  <LessonCard lesson={lesson} trackId={trackId} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* More lessons indicator */}
        {trackLessons.length < track.totalLessons && (
          <div className="p-4 rounded-xl bg-muted/50 text-center">
            <p className="text-sm text-muted-foreground">
              +{track.totalLessons - trackLessons.length} lições em breve
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default TrackDetailPage;
